// extracted by mini-css-extract-plugin
export default {"timeBoundaryContainer":"FirestoreMessageListTimeBoundaryItem_timeBoundaryContainer__OhXjo"};